import { render, staticRenderFns } from "./navbar-item-language-selector.vue?vue&type=template&id=e9c7ed98&scoped=true&"
import script from "./navbar-item-language-selector.vue?vue&type=script&lang=js&"
export * from "./navbar-item-language-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c7ed98",
  null
  
)

export default component.exports